import {Injectable} from '@angular/core';
import {PartnerSavePayload} from './payload/partnerSave.payload';
import {PartnerModel} from '../model/partner.model';
import {AbstractSaveOneService} from '../../../../core/service/v2/service/save/abstractSaveOne.service';
import {PartnerRepository} from '../../impl/service/ngrx/partner.repository';
import {PartnerDataServiceAdapter} from '../../impl/service/ngrx/partnerDataService.adapter';
import {PartnerPersonRepository} from '../../../modules/person/impl/service/ngrx/partnerPerson.repository';

@Injectable()
export class PartnerCRUDService extends AbstractSaveOneService<PartnerModel, PartnerSavePayload>{
    constructor(repository: PartnerRepository,
                dataService: PartnerDataServiceAdapter,
                private partnerPersonRepository: PartnerPersonRepository) {
        super(repository, dataService);
    }

    protected postSave(entity: PartnerModel) {
        this.partnerPersonRepository.clearCache();
    }

}
